import { render } from "./Creature.vue?vue&type=template&id=b1df7766"
import script from "./Creature.vue?vue&type=script&lang=js"
export * from "./Creature.vue?vue&type=script&lang=js"

import "./Creature.vue?vue&type=style&index=0&id=b1df7766&lang=scss"

import exportComponent from "D:\\repos\\rivendom-compendium\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__